'use strict';

const appendListMethod = require('../appendListMethod');

const REDEEM_FREQUENCY = {
  ONLY_ONCE: 'ONLY_ONCE',
  ONCE_PER_WEEK: 'ONCE_PER_WEEK',
  ONCE_PER_MONTH: 'ONCE_PER_MONTH',
  UNLIMITED: 'UNLIMITED',
};

module.exports = {
  AVAILABLE_REDEEM_FREQUENCY: appendListMethod(REDEEM_FREQUENCY),
  REDEEM_FREQUENCY,
};
